import React, { useState, useEffect } from 'react';
import * as signalR from '@microsoft/signalr';
import axios from 'axios';
import { guid } from '@solimat/solimat-web-endpoint/lib/user/dto';
import { useCheckTypeNotification } from "hooks/useCheckTypeNotification";
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { safeRedirect } from "../../utils/security";
import { notifications } from "@solimat/solimat-web-endpoint";


  const BASE_URL = import.meta.env.VITE_REACT_APP_NOTIFICACIONES_PATH || "";
  const FUNCTIONS_KEY = import.meta.env.VITE_REACT_APP_NOTIFICACIONES_KEY || "";
  const apiNotifications = new notifications.NotificationsService(BASE_URL, FUNCTIONS_KEY);

interface INotificationUpdate {
  usuarioId: guid,
  notificacionId: guid
}
interface INotificationRequest {
  id: guid,
  usuarioId: guid,
  titulo: string,
  mensaje: string,
  tipo: NotificacionTipo,
  scope: NotificacionScope,
  tipoPresatcion?: number,
  prestacionId?: guid,
  tipoContingencia?: number,
  tipoComponente?: number,
  componenteId?: guid
}
enum NotificacionScope {
  CITAS,
  PRESTACIONES_PACIENTES
}
enum NotificacionTipo {
  SIGNALR
}
interface ISignalRNotification {
  Id: guid,
  Text: string,
  Timestamp: Date
}

interface IToastNotification {
  notificationData?: INotificationRequest,
  signalRData?: ISignalRNotification
}

const ToastNotification: React.FC<IToastNotification> = ({ notificationData, signalRData }) => {
  const [redirectPath, setRedirectPath] = useState<any>({ pathname: '' });
  const { checkTypeNotification } = useCheckTypeNotification()
  useEffect(() => {
    let routeTo = checkTypeNotification(notificationData);
    if (routeTo !== undefined) {
      setRedirectPath(routeTo);
    }
    else {
      redirectPath.pathname = '/notificaciones';
      setRedirectPath(redirectPath);
    }
  }, [notificationData])

  const handleUpdateNotification = () => {
    redirect();
  }

  const redirect = () => {
    if (redirectPath?.pathname !== undefined && redirectPath.pathname !== '') {
      return safeRedirect(redirectPath.pathname);
    }
  }

  return (
    <a className="toast-notification"
      onClick={handleUpdateNotification}
    >
      <div className="icon-bell"></div>
      <div>
        <h4 className="title">Nueva notificacion</h4>
        <p className="text">{notificationData?.titulo ?? signalRData?.Text}</p>
      </div>
    </a>
  );

}

/* signalR hook */

const useSignalR = () => {
  const [newNotification, setNewNotification] = useState({});
  const [connectionState, setConnectionState] = useState(false);
  const [connectionHub, setConnectionHub] = useState<any>({});
  const protocol = new signalR.JsonHubProtocol();

  let options: any = null;
  let connection: signalR.HubConnection = null;
  let mess: any[] = [];
  
  let data = {
    username: '',
    defaultgroup: 'AzureSignalR',
    checked: false,
    newMessage: '',
    messages: mess,
    myConnectionId: '',
    ready: false
  };


  const handleStartSignalR = async (token: any) => {
    const userId = token.extension_id;

    // Función para obtener un nuevo token - se llama cada vez que SignalR necesita autenticarse
    const getAccessToken = async (): Promise<string> => {
      try {
        const res = await apiNotifications.negociate(userId);
        return res.data.accessToken;
      } catch (err) {
        console.error('Error obteniendo token de SignalR:', err);
        throw err;
      }
    };

    try {
      const res = await apiNotifications.negociate(userId);
      let info = res.data;

      options = {
        skipNegotiation: false,
        accessTokenFactory: getAccessToken
      };

      connection = new signalR.HubConnectionBuilder()
        .withUrl(info.url, options)
        .withHubProtocol(protocol)
        .withAutomaticReconnect({
          nextRetryDelayInMilliseconds: (retryContext) => {
            // Reintentar con delays incrementales: 0s, 2s, 10s, 30s, luego cada 30s
            if (retryContext.previousRetryCount === 0) return 0;
            if (retryContext.previousRetryCount === 1) return 2000;
            if (retryContext.previousRetryCount === 2) return 10000;
            return 30000;
          }
        })
        .configureLogging(signalR.LogLevel.Information)
        .build();

      // Manejar eventos de reconexión
      connection.onreconnecting((error) => {
        console.log('SignalR reconectando...', error);
        setConnectionState(false);
      });

      connection.onreconnected((connectionId) => {
        setConnectionState(true);
        // Re-unirse a los grupos después de reconectar
        if (token?.extension_roles) {
          let roles = JSON.parse(token.extension_roles) as string[];
          roles.map(g => connection.send("JoinUserToGroup", userId, g));
        }
      });

      connection.onclose((error) => {
        console.log('SignalR conexión cerrada', error);
        setConnectionState(false);
      });

      setConnectionHub(connection);

      addMessage('connecting...');

      await connection.start();

      if (connection && connection.state === signalR.HubConnectionState.Connected) {
        connection.on('onUserMessage', onUserMesasge);

        setConnectionState(true);
        addMessage('connected!');

        if (token?.extension_roles) {
          let roles = JSON.parse(token.extension_roles) as string[];
          addMessage(`user has ${roles.length} roles!`);
          roles.map(g => connection.send("JoinUserToGroup", userId, g));
        }
      }
    } catch (err) {
      console.error('Error iniciando SignalR:', err);
    }
  }
  function addMessage(message: any) {
  };
  let counter = 0;

  function onNewConnection(message: any) {
    if (!!message) {
      data.myConnectionId = message.connectionId ?? message.connection?.connectionId;
      if (!!data.myConnectionId) {
        let newConnectionMessage = {
          Id: counter++,
          Text: `${data.myConnectionId}esta conectado`
        };
        addMessage(newConnectionMessage);
      }
    }
  }
  function onUserMesasge(message: any) {
    toast(<ToastNotification
      notificationData={message}
      signalRData={message}
    />,
      {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: true
      }
    )
    setNewNotification(message)

  }
  function onGroupMesasge(message: any) {
    addMessage(message);
    toast(<ToastNotification
      notificationData={message}
      signalRData={message}
    />,
      {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: true
      }
    )
  }
  function onConnected(message: any) {
    addMessage(message);
  }
  const handleDisconnectSignalR = (connection: any) => {
  
    if (Object.keys(connection).length !== 0) {
      connection.stop();
     
    }

    setConnectionState(false);

  }

  return {
    newNotification,
    connectionState,
    handleStartSignalR,
    handleDisconnectSignalR,
    connectionHub
  };
}

export default useSignalR;